<template>
  <div class="route-menu">
    <index-view title="Danh mục menu" :filters="filters" 
    :getData="getData" 
    :getDetail="getDetail"
    :enableCreate="true"
    :createHandler ="postDetail"
    :updateHandler ="updateDetail"
    :deleteHandler ="conditionDelete"
    :headers="mainHeaders"
    :detailWidth="800" 
    :cellSlots="cellSlots" 
    :itemsPerPage="-1"
    tableKey="id" :showActions="true">
      <template #viewSection="{ item, selected, onInput, mode }" >
        <detail :item="item" :selected="selected" @input="onInput" :mode="mode"></detail>
      </template>
      
      <template #preTitle="{reload}">
        <v-chip small color="orange darken-2" dark @click="roots=[],reload()" class="mx-2">
          <v-icon small>mdi-home</v-icon>
        </v-chip>

        <!-- <v-chip v-show="root" small color="green darken-2" dark>
          {{ root }}
        </v-chip> -->
        <v-chip small color="green darken-4" v-for="(item, index ) in roots" :key="index" @click="roots=roots.slice(0, index-1), reload()" dark>
          <b>{{ item }}</b>
        </v-chip>
      </template>
      
      <template v-slot:[`icon`]="{ cell, reload }">
        <v-icon v-show="cell.icon">{{ cell.icon }}</v-icon>
      </template>

      <template v-slot:[`transTitle`]="{ cell }">
      <v-chip label small v-if="cell.type=='SECTION'" color="red darken-4" dark>{{ cell.type }}</v-chip>
      <v-chip label small v-if="cell.type=='MENU'" color="green" dark>{{ cell.type }}</v-chip>
      <v-chip label small v-if="cell.type=='SUBHEADER'" color="grey" dark>{{ cell.type }}</v-chip>
      <v-chip label small v-if="cell.type=='GROUP'" color="blue" dark>{{ cell.type }}</v-chip>
      {{ $t(cell.title) }}
      </template>
      
      <template v-slot:[`parentId`]="{ cell, reload }">
        <v-btn icon @click="pushRoot(cell.id, reload)" v-if="cell.type=='SECTION' || cell.type=='GROUP'">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      
      <template v-slot:[`order`]="{ cell, reload }">
        {{ cell.order }}
        <v-icon color="blue" style="cursor: pointer;" @click="changeOrder(cell.id, 'increase', reload)"> mdi-arrow-up</v-icon>
        <v-icon color="red" style="cursor: pointer;" @click="changeOrder(cell.id, 'decrease', reload)"> mdi-arrow-down</v-icon>
      </template>

    </index-view>
    
  </div>
</template>

<script>

import IndexView from '../../../components/CommonView/IndexView.vue';
import { conditionGets, Get, Post, Put, conditionDelete, changeOrder } from './api'
import { main, finalHeaders, readyHeaders } from './header'
import Detail from './Detail.vue'
import EmployeeDialog from '../../../components/Crud/Prompt/EmployeeDialog.vue';
const statusFilters = ['Tạo mới', 'Hoàn tất', 'Hủy']
export default {
  name: "RouteMenu",
  components: {
    IndexView,
    Detail,
    EmployeeDialog
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    }

  },
  data() {
    return {
      filters: [
        {name: 'id', label:'Id', type: 'text', value: '' },
        {name: 'group', label:'Nhóm', type: 'text', value: '' },
        {name: 'title', label:'Tiêu đề', type: 'text', value: '' },
      ],
      selected: null,
      action1Dialog: false,
      actionData: {
        month: null
      },
      finals: [],
      finalHeaders : finalHeaders,

      action2Dialog: false,
      action2Calendar: null,
      readySearch: '',
      readies: [],
      readyHeaders: readyHeaders,

      employeeDialog: false,
      employeeDialogMain: false,
      cellSlots: ['transTitle', 'parentId', 'order', 'icon'],
      roots: []
    }
  },
  watch: {
    action2Calendar(newVal) {
      this.getReady();
    },
    
  },
  methods: {
    detailInputHandler(value) {
      if(value) {
        this.$emit('input', value);
      }
    },
    updateHandler() {
      alert('submit')
    },
    getData() {
      return conditionGets(this.roots)
    },
    getDetail: Get,
    postDetail: (payload) => Post(payload),
    updateDetail: (id, payload) => Put(id, payload),
    changeOrder: changeOrder,
    conditionDelete: (id) => conditionDelete(id),
    // submit() {
    //   alert('submit from parent')
    // },

    //ready section
    getReady() {
      return getReady(this.action2Calendar).then(data => {
        this.readies = data.data;
      })
    },
    
    setReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return setReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    
    initReady() {
      //call api to set ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return initReady(this.action2Calendar).then(() => {
        this.getReady();
      })
    },

    generateReview() {
      //call api to generate review for ready items
      if(!this.action2Calendar) {
        alert('Vui lòng chọn kỳ đánh giá');
        return;
      }
      return generateReview(this.action2Calendar).then(() => {
        this.getReady();
      })
    },
    convertStatus(status) {
      if(status === 0) return {text:'Tạo mới', color:'cyan--text'}
      if(status === 1) return {text:'SM duyệt', color:'green--text'}
      if(status === 2) return {text:'Lưu trữ', color:'blue--text'}
      return {text:'Hủy', color:'red--text'}
    },
    pushRoot(id, reload) {
      // this.root=id
      if (!this.roots.includes(id)) {
        this.roots.push(id)
      }
      reload()
    }
  },
  mounted() {
  }
}
</script>